// extracted by mini-css-extract-plugin
module.exports = {"grid":"box_grid__LPZkz","bg-container":"box_bg-container__XA8u_"};